<template>
    <div>
        <div class="content-caption dashed">
            <span>审核信息</span>
        </div>
        <div class="simple-form">
            <div class="form-group center">
                <div class="form-label">
                    <label>申请描述</label>
                </div>
                <div class="form-value width-1-5x">
                    <span>{{ settleProof.applyDesc }}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>审核状态</label>
                </div>
                <div class="form-value width-1-5x">
                    <el-radio-group v-model="auditState">
                        <el-radio :label="1">通过</el-radio>
                        <el-radio :label="-1">拒绝</el-radio>
                    </el-radio-group>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>审核描述</label>
                </div>
                <div class="form-value width-1-5x">
                    <el-input type="textarea" :rows="5" v-model="auditDesc"></el-input>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>结算描述</label>
                </div>
                <div class="form-value width-1-5x">
                    <el-input type="textarea" :rows="5" v-model="memo"></el-input>
                </div>
            </div>
        </div>
        <div class="content-caption dashed">
            <span>结算单信息</span>
            <div class="shrink-tab fr" :class="showSettleInfoFlag? 'current': ''" @click="doShowSettleInfo()">
                <span>{{ showSettleInfoFlag ? '隐藏' : '展开' }}</span>
                <i :class="showSettleInfoFlag? 'el-icon-arrow-down': 'el-icon-arrow-right'"></i>
            </div>
        </div>
        <template v-if="showSettleInfoFlag">
            <div class="simple-form flex col-3">
                <div class="form-group">
                    <div class="form-label">
                        <label>结算单号</label>
                    </div>
                    <div class="form-value">
                        <span>{{ settleProof.innerNo || '' }}</span>
                    </div>
                </div>
                <div class="form-group">
                    <div class="form-label">
                        <label>记账凭证号</label>
                    </div>
                    <div class="form-value">
                        <span>{{ settleProof.reservedNo || '' }}</span>
                    </div>
                </div>
                <div class="form-group">
                    <div class="form-label">
                        <label>审批单号</label>
                    </div>
                    <div class="form-value">
                        <span>{{ settleProof.auditPoofNo || '' }}</span>
                    </div>
                </div>
                <div class="form-group">
                    <div class="form-label">
                        <label>供方公司名称</label>
                    </div>
                    <div class="form-value">
                        <span>{{ settleProof.sellerRealComName }}</span>
                    </div>
                </div>
                <div class="form-group">
                    <div class="form-label">
                        <label>供方公司编码</label>
                    </div>
                    <div class="form-value">
                        <span>{{ settleProof.sellerRealComCode }}</span>
                    </div>
                </div>
                <div class="form-group">
                    <div class="form-label">
                        <label>供方标识</label>
                    </div>
                    <div class="form-value">
                        <span>{{ settleProof.buyerInnerSellerCode }}</span>
                    </div>
                </div>
                <div class="form-group">
                    <div class="form-label">
                        <label>业务类型</label>
                    </div>
                    <div class="form-value">
                        <span>{{ settleBizTypeMap[settleProof.bizType] }}</span>
                    </div>
                </div>
                <div class="form-group">
                    <div class="form-label">
                        <label>单据状态</label>
                    </div>
                    <div class="form-value ">
                        <span class="font-red" v-if="settleProof.invalid">已作废</span>
                        <span v-else>{{ settleProof.proofStateText }}</span>
                    </div>
                </div>
            </div>
            <div class="simple-form flex col-3">
                <div class="form-group">
                    <div class="form-label">
                        <label>{{ settleProof.bizType == 1 ? '购置' : '服务' }}含税金额(元)</label>
                    </div>
                    <div class="form-value ">
                        <span>{{ (settleProof.settleAmount || 0).toFixed(2) }}</span>
                        <!--               6.14.7版本不实现，后续再考虑 TODO 2025-05-20       -->
<!--                        <a class="swb-btn swb-btn-link" @click="exportPdf(settleProof.id)" v-if="!settleProof.invalid && settleProof.bizType != 2 && settleProof.hasValidPayVoucher">付款单下载</a>-->
                    </div>
                </div>
                <div class="form-group">
                    <div class="form-label">
                        <label>{{ settleProof.bizType == 1 ? '购置' : '服务' }}未税金额(元)</label>
                    </div>
                    <div class="form-value ">
                        <span>{{ (settleProof.settleNtxAmount || 0).toFixed(2) }}</span>
                    </div>
                </div>
                <div class="form-group">
                    <div class="form-label">
                        <label>{{ settleProof.bizType == 1 ? '购置' : '服务' }}税额(元)</label>
                    </div>
                    <div class="form-value ">
                        <span>{{ (settleProof.taxAmount || 0).toFixed(2) }}</span>
                    </div>
                </div>
                <div class="form-group">
                    <div class="form-label">
                        <label>发票含税金额(元)</label>
                    </div>
                    <div class="form-value ">
                        <span>{{ (settleProof.invoiceAmount || 0).toFixed(2) }}</span>
                    </div>
                </div>
                <div class="form-group">
                    <div class="form-label">
                        <label>发票未税金额(元)</label>
                    </div>
                    <div class="form-value ">
                        <span>{{ (settleProof.invoiceNtxAmount || 0).toFixed(2) }}</span>
                    </div>
                </div>
                <div class="form-group">
                    <div class="form-label">
                        <label>发票税额(元)</label>
                    </div>
                    <div class="form-value ">
                        <span>{{ (settleProof.invoiceTaxAmount || 0).toFixed(2) }}</span>
                    </div>
                </div>
                <div class="form-group">
                    <div class="form-label">
                        <label>差额含税金额(元)</label>
                    </div>
                    <div class="form-value ">
                        <span>{{ ((settleProof.settleAmount || 0) - (settleProof.invoiceAmount || 0)).toFixed(2) }}</span>
                    </div>
                </div>
                <div class="form-group">
                    <div class="form-label">
                        <label>差额未税金额(元)</label>
                    </div>
                    <div class="form-value ">
                        <span>{{ ((settleProof.settleNtxAmount || 0) - (settleProof.invoiceNtxAmount || 0)).toFixed(2) }}</span>
                    </div>
                </div>
                <div class="form-group">
                    <div class="form-label">
                        <label>差额税额(元)</label>
                    </div>
                    <div class="form-value ">
                        <span>{{ (settleProof.taxDiffAmount || 0).toFixed(2) }}</span>
                    </div>
                </div>
            </div>
            <div class="simple-form flex col-3">
                <div class="form-group">
                    <div class="form-label">
                        <label>申请描述</label>
                    </div>
                    <div class="form-value ">
                        <span>{{ settleProof.applyDesc || '' }}</span>
                    </div>
                </div>
                <div class="form-group">
                    <div class="form-label">
                        <label>结算描述</label>
                    </div>
                    <div class="form-value ">
                        <span>{{ settleProof.memo || '' }}</span>
                    </div>
                </div>
                <div class="form-group" v-if="settleProof.pullBackNo != null && settleProof.pullBackNo != ''">
                    <div class="form-label">
                        <label>已冲销</label>
                    </div>
                    <div class="form-value">
                        <span v-if="settleProof.pulledBack">是</span>
                        <span v-else>否</span>
                    </div>
                </div>
                <div class="form-group" v-if="settleProof.pullBackNo != null && settleProof.pullBackNo != ''">
                    <div class="form-label">
                        <label>冲销原因</label>
                    </div>
                    <div class="form-value">
                        <span>{{ settleProof.rejectCause || '' }}</span>
                    </div>
                </div>
                <div class="form-group" v-if="settleProof.pullBackNo != null && settleProof.pullBackNo != ''">
                    <div class="form-label">
                        <label>冲销单号</label>
                    </div>
                    <div class="form-value">
                        <span>{{ settleProof.pullBackNo || '' }}</span>
                    </div>
                </div>
                <div class="form-group" v-if="!settleProof.jointInvokeDone && settleProof.jointInvokeErrMsg != null">
                    <div class="form-label">
                        <label>对接推送失败原因</label>
                    </div>
                    <div class="form-value">
                        <span>{{ settleProof.jointInvokeErrMsg || '' }}</span>
                    </div>
                </div>
            </div>
        </template>
        <div class="content-caption dashed">
            <span>发票</span>
            <div class="shrink-tab fr" :class="showInvoiceFlag? 'current': ''" @click="doShowInvoice()">
                <span>{{ showInvoiceFlag ? '隐藏' : '展开' }}</span>
                <i :class="showInvoiceFlag? 'el-icon-arrow-down': 'el-icon-arrow-right'"></i>
            </div>
        </div>
        <el-table :data="settleProof.settleInvoiceItemList" border maxHeight="400" style="width: 100%" v-if="showInvoiceFlag">
            <el-table-column align="left" prop="actualNo" label="发票号" fixed show-overflow-tooltip></el-table-column>
            <el-table-column align="left" prop="actualCode" label="发票代码" fixed show-overflow-tooltip></el-table-column>
            <el-table-column align="left" prop="buyerTaxPayerNo" label="纳税人识别号" show-overflow-tooltip></el-table-column>
            <el-table-column align="right" width="150" prop="actualAmount" label="含税金额(元)" show-overflow-tooltip>
                <template slot-scope="scope">
                    <span>{{ (scope.row.actualAmount || 0).toFixed(2) }}</span>
                </template>
            </el-table-column>
            <el-table-column align="right" width="150" prop="actualNtxAmount" label="未税金额(元)" show-overflow-tooltip>
                <template slot-scope="scope">
                    <span>{{ (scope.row.actualNtxAmount || 0).toFixed(2) }}</span>
                </template>
            </el-table-column>
            <el-table-column align="right" width="150" prop="actualTaxAmount" label="税额(元)">
                <template slot-scope="scope">
                    <span>{{ (scope.row.actualTaxAmount || 0).toFixed(2) }}</span>
                </template>
            </el-table-column>
            <el-table-column align="center" width="160" prop="actualDate" label="发票日期"></el-table-column>
            <el-table-column align="center" label="操作" width="100" fixed="right">
                <template slot-scope="scope">
                    <a class="swb-btn-link" @click="viewInvoiceFile(scope.row)">查看附件</a>
                </template>
            </el-table-column>
        </el-table>
        <div class="content-caption dashed" v-if="settleProof.bizType == 1">
            <span>商品列表</span>
            <div class="shrink-tab fr" :class="showGoodsFlag? 'current': ''" @click="doShowGoods()">
                <span>{{ showGoodsFlag ? '隐藏' : '展开' }}</span>
                <i :class="showGoodsFlag? 'el-icon-arrow-down': 'el-icon-arrow-right'"></i>
            </div>
        </div>
        <el-table :data="settleProof.settleBizSrcList" border maxHeight="400" style="width: 100%" v-if="settleProof.bizType == 1 && showGoodsFlag">
            <el-table-column align="center" prop="bizVoucherInnerNo" fixed label="验收单号" show-overflow-tooltip>
                <template slot-scope="scope">
                    <a ref="#" class="table-cell-link" @click="toPurchReceipt(scope.row)">{{ scope.row.bizVoucherInnerNo }}</a>
                </template>
            </el-table-column>
            <el-table-column align="left" width="120" prop="buyerCostCenterCode" label="成本中心"></el-table-column>
            <el-table-column align="left" width="200" prop="bizUnitName" label="门店名称" show-overflow-tooltip></el-table-column>
            <el-table-column align="right" width="100" prop="amount" label="含税金额(元)">
                <template slot-scope="scope">
                    <span>{{ (scope.row.amount || 0).toFixed(2) }}</span>
                </template>
            </el-table-column>
            <el-table-column align="right" width="100" prop="ntxAmount" label="未税金额(元)">
                <template slot-scope="scope">
                    <span>{{ (scope.row.amount - scope.row.taxAmount).toFixed(2) }}</span>
                </template>
            </el-table-column>
            <el-table-column align="center" prop="baseVoucherInnerNo" label="购置单号" show-overflow-tooltip>
                <template slot-scope="rows">
                    <span v-if="rows.row.cgVoucherNo != null"><a ref="#" class="table-cell-link" @click="toRequireVoucher(rows.row)">{{ rows.row.cgVoucherNo }}</a></span>
                    <span v-else>——</span>
                </template>
            </el-table-column>
            <el-table-column align="right" width="100" prop="quantity" label="数量"></el-table-column>
            <el-table-column align="center" width="160" prop="checkTime" label="验收时间"></el-table-column>
            <el-table-column align="center" prop="contractNo" label="合同编号" show-overflow-tooltip>
                <template slot-scope="rows">
                    <span v-if="settleProof.contractNo != null"><a ref="#" class="table-cell-link" @click="toContract(rows.row)">{{ settleProof.contractNo }}</a></span>
                    <span v-else>——</span>
                </template>
            </el-table-column>
            <el-table-column align="center" width="200" label="操作" fixed="right">
                <template slot-scope="scope">
                    <a class="swb-btn-link" @click="viewPurchReceipt(scope.row)">验收详情</a>
                </template>
            </el-table-column>
        </el-table>
        <div class="content-caption dashed" v-if="settleProof.bizType == 2">
            <span>验收单列表</span>
            <div class="shrink-tab fr" :class="showServWorkFlag? 'current': ''" @click="doShowServWork()">
                <span>{{ showServWorkFlag ? '隐藏' : '展开' }}</span>
                <i :class="showServWorkFlag? 'el-icon-arrow-down': 'el-icon-arrow-right'"></i>
            </div>
        </div>
        <el-table :data="settleProof.settleBizSrcList" border maxHeight="400" style="width: 100%" v-if="settleProof.bizType == 2 && showServWorkFlag">
            <el-table-column align="center" prop="contractNo" fixed label="合同编号" show-overflow-tooltip>
                <template slot-scope="rows">
                    <span v-if="settleProof.contractNo != null"><a ref="#" class="table-cell-link" @click="toContract(rows.row)">{{ settleProof.contractNo }}</a></span>
                    <span v-else>——</span>
                </template>
            </el-table-column>
            <el-table-column align="center" prop="bizVoucherInnerNo" fixed label="验收单号" show-overflow-tooltip>
                <template slot-scope="scope">
                    <a ref="#" class="table-cell-link" @click="toServcWorkReceipt(scope.row)">{{ scope.row.bizVoucherInnerNo }}</a>
                </template>
            </el-table-column>
            <el-table-column align="left" width="120" prop="buyerCostCenterCode" label="成本中心"></el-table-column>
            <el-table-column align="left" width="200" prop="bizUnitName" label="门店名称" show-overflow-tooltip></el-table-column>
            <el-table-column align="center" width="160" prop="checkTime" label="验收时间"></el-table-column>
            <el-table-column align="right" width="100" prop="amount" label="含税价(元)">
                <template slot-scope="scope">
                    <span>{{ (scope.row.amount || 0).toFixed(2) }}</span>
                </template>
            </el-table-column>
            <el-table-column align="right" width="100" prop="ntxAmount" label="未税价(元)">
                <template slot-scope="scope">
                    <span>{{ (scope.row.amount - scope.row.taxAmount).toFixed(2) }}</span>
                </template>
            </el-table-column>
            <el-table-column align="left" prop="buyerBizTag" label="结算标签" width="100" show-overflow-tooltip>
                <template slot-scope="scope">
                    <div v-if="scope.row.buyerBizTag != null && scope.row.buyerBizTag != ''" v-for="tagId in scope.row.buyerBizTag.split('|')">
                        <span class="swb-tags swb-tags-success mr5" v-if="tagId != null && tagId != '' && getBizTagNameById(tagId) != null">{{ getBizTagNameById(tagId) }}</span>
                    </div>
                </template>
            </el-table-column>
            <el-table-column align="center" width="100" prop="settleFree" label="无需结算">
                <template slot-scope="scope">
                    <span>{{ scope.row.settleFree ? '是' : '否' }}</span>
                </template>
            </el-table-column>
            <el-table-column align="center" width="100" label="操作">
                <template slot-scope="scope">
                    <a class="swb-btn-link" @click="toSetBuyerBizTag($event, scope.row)">设置标签</a>
                </template>
            </el-table-column>
        </el-table>
        <div class="content-caption dashed" v-if="(settleProof.contractId != -1 && contractPhasedPaymentAllowed) || (settleProof.contractId == -1 && phasedPaymentAllowed)">
            <span>付款阶段</span>
            <div class="shrink-tab fr" :class="showPayPhasesFlag? 'current': ''" @click="doShowPayPhases()">
                <span>{{ showPayPhasesFlag ? '隐藏' : '展开' }}</span>
                <i :class="showPayPhasesFlag? 'el-icon-arrow-down': 'el-icon-arrow-right'"></i>
            </div>
        </div>
        <el-table :data="settlePayPhaseInfo.settlePayPhaseList" ref="multipleTable" border :span-method="arraySpanMethod" v-if="settleProof.contractId != -1 && contractPhasedPaymentAllowed && showPayPhasesFlag">
            <el-table-column align="left" prop="phaseName" label="阶段名称" show-overflow-tooltip></el-table-column>
            <el-table-column align="center" prop="phaseType" label="阶段类型" width="150" show-overflow-tooltip>
                <template slot-scope="rows">
                    <span>{{ payPhaseTypeMap[rows.row.phaseType] }}</span>
                </template>
            </el-table-column>
            <el-table-column align="center" prop="acntPeriodStartDate" label="账期起算日" width="150" show-overflow-tooltip></el-table-column>
            <el-table-column align="right" prop="acntPeriodDays" width="150" label="账期" v-if="settlePayPhaseInfo.acntPeriodForm == 1"></el-table-column>
            <el-table-column align="right" prop="phaseGapDays" width="150" label="当前阶段间隔天数" v-if="settlePayPhaseInfo.acntPeriodForm == 2"></el-table-column>
            <el-table-column align="center" prop="calcBasis" label="金额计算依据" width="150" show-overflow-tooltip>
                <template slot-scope="rows">
                    <span>{{ amtCalcMethodMap[rows.row.calcBasis] }}</span>
                </template>
            </el-table-column>
            <el-table-column align="right" prop="ratio" label="付款比例(%)" width="150" show-overflow-tooltip></el-table-column>
            <el-table-column align="right" prop="amount" label="付款金额" width="150" show-overflow-tooltip></el-table-column>
            <el-table-column align="center" prop="payMethod" width="150" label="付款方式">
                <template slot-scope="rows">
                    <span>{{ payMethodMap[rows.row.payMethod] }}</span>
                </template>
            </el-table-column>
        </el-table>
        <el-form :model="settlePayPhaseInfo" ref="ruleForm" v-if="settleProof.contractId == -1 && phasedPaymentAllowed && showPayPhasesFlag">
            <table class="custom-tbl error-prompt">
                <thead class="head">
                <tr class="row">
                    <th class="text-align: left; required">阶段名称</th>
                    <th width="200" class="text-align: left; required">阶段类型</th>
                    <th width="200" class="text-align: right; required">账期起算日</th>
                    <th width="100" class="text-align: right; required" v-if="settlePayPhaseInfo.acntPeriodForm == 1">账期(天)</th>
                    <th width="140" class="text-align: right; required" v-if="settlePayPhaseInfo.acntPeriodForm == 2">当期阶段间隔天数</th>
                    <th width="200" class="text-align: left; required">金额计算依据</th>
                    <th width="120" class="text-align: left; required">付款比例(%)</th>
                    <th width="120" class="text-align: left;">付款金额</th>
                    <th width="150" class="text-align: right; required">付款方式</th>
                    <th width="100">操作</th>
                </tr>
                </thead>
                <tbody class="body">
                <tr v-for="(item,index) in settlePayPhaseInfo.settlePayPhaseList" class="row">
                    <td :rowspan="item.rowspan" v-if="item.visible">
                        <el-form-item :prop="'settlePayPhaseList.' + index + '.phaseName'" :rules="{validator: checkPhaseName, trigger: 'blur'}">
                            <el-input class="fl" style="width: 80%;" type="text" v-model="item.phaseName" @blur="changePhaseName(index)"></el-input>
                            <a class="swb-btn-link fr inline-block" @click="addPhaseItem(index)" v-if="item.rowspan < payMethodList.length">增加付款次数</a>
                        </el-form-item>
                    </td>
                    <td :rowspan="item.rowspan" v-if="item.visible">
                        <el-form-item>
                            <el-select v-model="item.phaseType" @change="changePhaseType(index)">
                                <el-option v-for="item in phaseTypeList" :key="item.value" :label="item.text" :value="item.value"></el-option>
                            </el-select>
                        </el-form-item>
                    </td>
                    <td :rowspan="item.rowspan" v-if="item.visible"><!-- 折旧起算日 calcBasis -->
                        <el-form-item :prop="'settlePayPhaseList.' + index + '.acntPeriodStartDate'" :rules="{required: true, type : 'date', message: '请选择日期', trigger: 'change'}">
                            <el-date-picker style="width: 120px;" v-model="item.acntPeriodStartDate" type="date" format="yyyy-MM-dd" placeholder="选择日期" @change="changeAcntPeriodStartDate(index)"></el-date-picker>
                        </el-form-item>
                    </td>
                    <td class="text-right" :rowspan="item.rowspan" v-if="settlePayPhaseInfo.acntPeriodForm == 1 && item.visible"><!-- 账期(天) acntPeriodDays -->
                        <el-form-item :prop="'settlePayPhaseList.' + index + '.acntPeriodDays'" :rules="{validator : validateIntNotNull, trigger: 'blur'}">
                            <el-input v-model.number="item.acntPeriodDays" @change="changeAcntPeriodDays(index)"></el-input>
                        </el-form-item>
                    </td>
                    <td class="text-right" :rowspan="item.rowspan" v-if="settlePayPhaseInfo.acntPeriodForm == 2 && item.visible"> <!-- 当期阶段间隔天数 phaseGapDays -->
                        <el-form-item :prop="'settlePayPhaseList.' + index + '.phaseGapDays'" :rules="{validator : validateIntNotNull, trigger: 'blur'}">
                            <el-input v-model.number="item.phaseGapDays" @change="changePhaseGapDays(index)"></el-input>
                        </el-form-item>
                    </td>
                    <td><!-- 金额计算依据 calcBasis -->
                        <el-form-item>
                            <el-select v-model="item.calcBasis">
                                <el-option v-for="item in amtCalcMethodList" :key="item.value" :label="item.text" :value="item.value"></el-option>
                            </el-select>
                        </el-form-item>
                    </td>
                    <td class="text-right">
                        <el-form-item :prop="'settlePayPhaseList.' + index + '.ratio'" :rules="{validator: validateRatio, trigger: 'blur'}">
                            <el-input v-model="item.ratio" @blur="changeRatio(index)"></el-input>
                        </el-form-item>
                    </td>
                    <td class="text-right">
                        <span>{{ item.amount }}</span>
                    </td>
                    <td><!-- 付款方式 payMethod -->
                        <el-form-item>
                            <el-select v-model="item.payMethod">
                                <el-option v-for="item in payMethodList" :key="item.value" :label="item.text" :value="item.value"></el-option>
                            </el-select>
                        </el-form-item>
                    </td>
                    <td>
                        <div @click="payPhaseRemoveItem(index);" class="swb-btn swb-btn-link">
                            <span>移除</span>
                        </div>
                    </td>
                </tr>
                </tbody>
                <tfoot class="foot">
                <tr class="row"
                    v-if="settlePayPhaseInfo.settlePayPhaseList[settlePayPhaseInfo.settlePayPhaseList.length - 1] == null || settlePayPhaseInfo.settlePayPhaseList[settlePayPhaseInfo.settlePayPhaseList.length - 1].phaseType != 9">
                    <td colspan="9" style="padding: 10px; border: 1px solid #dfe6ec; text-align: center;">
                        <div @click="addSettlePayPhase();" class="swb-btn swb-btn-link">
                            <i class="icon iconfont icon-jiahao mr5"></i>
                            <span>添加阶段</span>
                        </div>
                    </td>
                </tr>
                </tfoot>
            </table>
        </el-form>

        <div class="content-caption dashed">
            <span>结算付款项</span>
            <div class="shrink-tab fr" :class="showPayInfoFlag? 'current': ''" @click="doShowPayInfo()">
                <span>{{ showPayInfoFlag ? '隐藏' : '展开' }}</span>
                <i :class="showPayInfoFlag? 'el-icon-arrow-down': 'el-icon-arrow-right'"></i>
            </div>
        </div>
        <el-table :data="settleProof.settlePayItemList" border maxHeight="400" style="width: 100%" v-if="showPayInfoFlag">
            <el-table-column align="center" width="180" fixed prop="payVoucherNo" label="付款单号" show-overflow-tooltip>
                <template slot-scope="rows">
                    <span v-if="rows.row.payVoucherNo != null"><a ref="#" class="table-cell-link" @click="toPayVoucher(rows.row)">{{ rows.row.payVoucherNo }}</a></span>
                    <span v-else>——</span>
                </template>
            </el-table-column>
            <el-table-column align="center" width="80" prop="staffLoan" label="员工借款" show-overflow-tooltip>
                <template slot-scope="rows">
                    <span class="font-red" v-if="rows.row.staffLoan">是</span>
                    <span v-else>否</span>
                </template>
            </el-table-column>
            <el-table-column align="left" prop="subject" label="付款主题" show-overflow-tooltip></el-table-column>
            <el-table-column align="center" width="80" prop="payWay" label="付款途径" show-overflow-tooltip>
                <template slot-scope="rows">
                    <span>{{ payWayMap[rows.row.payWay] }}</span>
                </template>
            </el-table-column>
            <el-table-column align="right" width="150" prop="amount" label="付款金额(元)" show-overflow-tooltip>
                <template slot-scope="rows">
                    <span>{{ (rows.row.amount || 0).toFixed(2) }}</span>
                </template>
            </el-table-column>
            <el-table-column align="center" width="100" prop="auditState" label="审核状态" show-overflow-tooltip>
                <template slot-scope="rows">
                    <span>{{ auditStateMap[rows.row.auditState] }}</span>
                </template>
            </el-table-column>
            <el-table-column align="center" width="90" prop="payResult" label="结果状态">
                <template slot-scope="rows">
                    <span v-if="rows.row.payResult == 0">待付款</span>
                    <span v-else-if="rows.row.payResult == -1">付款失败</span>
                    <span v-else>付款成功</span>
                </template>
            </el-table-column>
        </el-table>

        <swb-dt-popover ref="popoverRef" classes="popper-tabs">
            <swb-biz-tag-list-for-select :bizAspect="bizAspect" :selectIds="tagIds" ref="swb_biz_tag_list_for_select" @notity-bizTag-comfirm="doBizTagConfirm" @notity-bizTag-cancel="doBizTagCancel"></swb-biz-tag-list-for-select>
        </swb-dt-popover>
    </div>

</template>

<script>
import {Utils} from '../../app.base'
import {Vue, MsgBox, Routes, getComnMerchantBizTag} from '../../app.vues'
import {openPayVoucherInfoPdfDlg} from '../payment/ActRecDlg'
import {checkUserActionPerm} from '../index'
import {openPurchReceiptDetailDlg, openPurchReceiptTmpDetailDlg} from '../receipt/showDlg'
import {getRealCtrlParam} from "../asset/assetMain";
import {showRouteLayer} from "../ctrl/RouteLayer";
import {openPageRouteUrl} from '../../../src/app.conf'

import settleApi from '../../api/settle'

import SwbPurchReceiptList from '../receipt/PurchReceiptList';

Routes.add(SwbPurchReceiptList);

import SwbPurchReceiptTmpList from '../receipt/PurchReceiptTmpList';

Routes.add(SwbPurchReceiptTmpList);

import SwbServcWorkReceiptList from '../receipt/ServcWorkReceiptList';

Routes.add(SwbServcWorkReceiptList);

import SwbDeviceRequireVoucherManager from '../retailer/DeviceRequireVoucherManager';

Routes.add(SwbDeviceRequireVoucherManager);

import SwbGoodsPurchContractList from '../contract/GoodsPurchContractList';

Routes.add(SwbGoodsPurchContractList);

import SwbServcPurchContractList from '../contract/ServcPurchContractList';

Routes.add(SwbServcPurchContractList);

import SwbIntegPurchContractList from '../contract/IntegPurchContractList';

Routes.add(SwbIntegPurchContractList);

import SwbContractGoodsOrderList from '../order/ContractGoodsOrderList';

Routes.add(SwbContractGoodsOrderList);

import SwbGoodsOrderList from '../order/GoodsOrderList';

Routes.add(SwbGoodsOrderList);

import SwbContractServcOrderList from '../servcOrder/ContractServcOrderList';

Routes.add(SwbContractServcOrderList);

import SwbServcOrderList from '../servcOrder/ServcOrderList';

Routes.add(SwbServcOrderList);

import SwbPayVoucherList from '../payment/PayVoucherList';

Routes.add(SwbPayVoucherList);

import SwbRefundVoucherOfVendorList from '../payment/RefundVoucherOfVendorList';

Routes.add(SwbRefundVoucherOfVendorList);

import SwbRefundVoucherOfServicerList from '../payment/RefundVoucherOfServicerList';

Routes.add(SwbRefundVoucherOfServicerList);

import SwbBizTagListForSelect from '../bizTag/BizTagListForSelect';

Vue.regist(SwbBizTagListForSelect);

import SwbInvoiceVoucherInfo from '../invoiceVoucher/InvoiceVoucherInfo';

Vue.regist(SwbInvoiceVoucherInfo);

let bizTagObj = null;

export default {
    name: 'swb-settle-proof-audit',
    desc: '结算单审核',
    props: ["proofId", "parentPath"],
    data: function () {
        return {
            settleProof: {},
            //
            settleBizTypeMap: getEnumMap("settleBizType", "value2text"),
            tradeSrcTypeMap: getEnumMap("tradeSrcType", "value2text"),
            tradeTypeMap: getEnumMap('tradeType', 'value2text'),
            orderTypeMap: getEnumMap('orderType', 'value2text'),
            payWayMap: getEnumMap('payWay', 'value2text'),
            auditStateMap: getEnumMap('auditState', 'value2text'),
            payResultMap: getEnumMap('resultState', 'value2text'),
            applyStateInitial: getEnumInfoWith('applyState', 'name', 'Initial').value,
            applyStateApplied: getEnumInfoWith('applyState', 'name', 'Applied').value,
            auditStateInitial: getEnumInfoWith('auditState', 'name', 'Initial').value,
            auditStateAuditFail: getEnumInfoWith('auditState', 'name', 'AuditFail').value,
            auditStateAuditPass: getEnumInfoWith('auditState', 'name', 'AuditPass').value,
            bizAspect: 0,
            tagIds: [],
            showSettleInfoFlag: true,
            showInvoiceFlag: true,
            showGoodsFlag: true,
            showServWorkFlag: true,
            showPayInfoFlag: true,
            showPayPhasesFlag: true,
            payPeriodTypeMap: getEnumMap('payPeriodType', 'value2text'),
            payPhaseTypeMap: getEnumMap('payPhaseType', 'value2text'),
            amtCalcMethodMap: getEnumMap('amtCalcMethod', 'value2text'),
            payMethodMap: getEnumMap('payMethod', 'value2text'),
            phaseTypeList: getEnumList('payPhaseType') || [],
            payMethodList: getEnumList('payMethod') || [],
            amtCalcMethodList: [],
            //
            auditState: 1,
            auditDesc: null,
            memo: null,
            settlePayPhaseInfo: {
                acntPeriodForm: 2, // 付款账期形式
                settlePayPhaseList: [] // 付款阶段
            },
            contractPhasedPaymentAllowed: true,
            phasedPaymentAllowed: true
        }
    },
    created: function () {
        //
        bizTagObj = getComnMerchantBizTag();
        bizTagObj.loadSelectBizTagByBizAspect(this.bizAspect, function (dataList) {
        });
        this.getSettleProofDetail();

        // 金额计算依据
        let amtCalcMethodList = [];
        let amtCalcMethods = getEnumList('amtCalcMethod') || [];
        let amtCalcMethodByAmount = getEnumInfoWith('amtCalcMethod', 'name', 'ByAmount');
        for (let i = 0; i < amtCalcMethods.length; i++) {
            let amtCalcMethod = amtCalcMethods[i];
            if (amtCalcMethod.name != amtCalcMethodByAmount.name) {
                amtCalcMethodList.push(amtCalcMethod);
            }
        }
        this.amtCalcMethodList = Utils.merge([], amtCalcMethodList);
    },
    methods: {
        // 隐藏、展开
        doShowSettleInfo: function () {
            this.showSettleInfoFlag = !this.showSettleInfoFlag;
        },
        // 隐藏、展开
        doShowInvoice: function () {
            this.showInvoiceFlag = !this.showInvoiceFlag;
        },
        // 隐藏、展开
        doShowGoods: function () {
            this.showGoodsFlag = !this.showGoodsFlag;
        },
        // 隐藏、展开
        doShowServWork: function () {
            this.showServWorkFlag = !this.showServWorkFlag;
        },
        // 隐藏、展开
        doShowPayInfo: function () {
            this.showPayInfoFlag = !this.showPayInfoFlag;
        },
        // 隐藏、展开
        doShowPayPhases: function () {
            this.showPayPhasesFlag = !this.showPayPhasesFlag;
        },
        checkActionPerm: function (action, targetPostId) {
            return checkUserActionPerm(this.parentPath, action, targetPostId);
        },
        getBizTagNameById(tagId) {
            if (!Utils.isNoB(tagId)) {
                let tagId2 = parseInt(tagId);
                if (!Utils.isNoB(tagId2)) {
                    return bizTagObj.getBizTagNameById(tagId2);
                }
            }
            return null;
        },
        getProofStateText: function (row) {
            let applyState = row.applyState;
            let auditState = row.auditState;
            let invalid = row.invalid;
            if (Utils.isTrue(invalid)) {
                return "已作废";
            } else if (applyState == this.applyStateInitial) {
                return "待申请";
            } else if (applyState == this.applyStateApplied && auditState == this.auditStateInitial) {
                return "待审核";
            } else if (auditState == this.auditStateAuditPass) {
                return "审核通过";
            } else if (auditState == this.auditStateAuditFail) {
                return "审核未通过";
            }
            return '';
        },
        // 结算单详情
        getSettleProofDetail: function () {
            let self = this;
            //
            let msgBoxDlg = MsgBox.loading();
            settleApi.getSettleProof(self.proofId, function (result) {
                msgBoxDlg.close();
                if (result.type == 'info') {
                    let settleProof = result.data || {};
                    settleProof.proofStateText = self.getProofStateText(settleProof);
                    //
                    self.memo = settleProof.memo;
                    self.settlePayPhaseInfo.acntPeriodForm = settleProof.acntPeriodForm;
                    let settlePayPhaseList = settleProof.settlePayPhaseList || [];
                    let settlePayPhases = [];
                    if (!Utils.isNoB(settlePayPhaseList) && settlePayPhaseList.length > 0) {
                        let settlePayPhaseListX = [];
                        for (let i = 0; i < settlePayPhaseList.length; i++) {
                            let settlePayPhase = settlePayPhaseList[i];
                            let settlePayItemList = settlePayPhase.settlePayItemList;
                            settlePayItemList.forEach(function (item){
                                item.phaseType = settlePayPhase.phaseType;
                                item.acntPeriodStartDate = settlePayPhase.acntPeriodStartDate;
                                item.acntPeriodDays = settlePayPhase.acntPeriodDays;
                                item.phaseGapDays = settlePayPhase.phaseGapDays;
                                item.acntPeriodBasis = settlePayPhase.acntPeriodBasis;
                                settlePayPhaseListX.push(item);
                            });
                        }
                        settlePayPhases = settlePayPhaseListX;
                        if (settleProof.contractId != -1) {
                            let preRow = null;
                            // 循环settlePayPhases
                            for (let i = 0; i < settlePayPhases.length; i++) {
                                settlePayPhases[i].rowspan = 1;
                                if (preRow == null) {
                                    preRow = settlePayPhases[i];
                                } else if (preRow.phaseName == settlePayPhases[i].phaseName) {
                                    preRow.rowspan++;
                                    settlePayPhases[i].rowspan = 0;
                                } else {
                                    preRow = settlePayPhases[i];
                                }
                            }
                        } else {
                            let preRow = null;
                            // 循环settlePayPhases
                            for (let i = 0; i < settlePayPhases.length; i++) {
                                settlePayPhases[i].rowspan = 1;
                                settlePayPhases[i].visible = true;
                                settlePayPhases[i].rowFlag = 'row' + i;
                                settlePayPhases[i]._originalPhaseName = settlePayPhases[i].phaseName;
                                settlePayPhases[i].acntPeriodStartDate = new Date(settlePayPhases[i].acntPeriodStartDate);
                                if (preRow == null) {
                                    preRow = settlePayPhases[i];
                                } else if (preRow.phaseName == settlePayPhases[i].phaseName) {
                                    preRow.rowspan++;
                                    settlePayPhases[i].rowFlag = preRow.rowFlag;
                                    settlePayPhases[i].visible = false;
                                } else {
                                    preRow = settlePayPhases[i];
                                }
                            }
                        }
                    }
                    self.settlePayPhaseInfo.settlePayPhaseList = settlePayPhases;

                    self.settleProof = Utils.merge({}, settleProof);

                    if (settleProof.contractId != -1) {
                        getRealCtrlParam('contract.settle.phased.payment.allowed', function (result) {
                            self.contractPhasedPaymentAllowed = Utils.isTrue(result);
                        });
                    } else {
                        getRealCtrlParam('tmppurch.settle.phased.payment.allowed', function (result) {
                            self.phasedPaymentAllowed = Utils.isTrue(result);
                        });
                    }
                } else {
                    MsgBox.warning(result.message);
                }
            });
        },
        // 跳转验收单列表
        toPurchReceipt: function (row) {
            let params = {
                innerNo: row.bizVoucherInnerNo
            };
            let hashUrl = null;
            if (Utils.isTrue(this.settleProof.tmpBizFlag)) {
                hashUrl = Utils.makeUrl(SwbPurchReceiptTmpList.path, params);
            } else {
                hashUrl = Utils.makeUrl(SwbPurchReceiptList.path, params);
            }
            openPageRouteUrl(null, "/bench/home", hashUrl);
        },
        // 跳转工单验收单列表
        toServcWorkReceipt: function (row) {
            let params = {
                innerNo: row.bizVoucherInnerNo
            };
            let hashUrl = Utils.makeUrl(SwbServcWorkReceiptList.path, params);
            openPageRouteUrl(null, "/bench/home", hashUrl);
        },
        // 跳转请购单列表
        toRequireVoucher: function (row) {
            let params = {
                innerNo: row.cgVoucherNo
            };
            let hashUrl = Utils.makeUrl(SwbDeviceRequireVoucherManager.path, params);
            openPageRouteUrl(null, "/bench/home", hashUrl);
        },
        // 跳转合同列表
        toContract: function (row) {
            let params = {
                no: this.settleProof.contractNo,
                currentRealComId: this.settleProof.buyerRealComId
            };
            let settleBizType = getEnumInfoWith('settleBizType', 'value', row.bizType);
            let path = null;
            if (settleBizType != null && settleBizType.name == 'Servc') {
                path = SwbServcPurchContractList.path;
            } else {
                path = SwbGoodsPurchContractList.path;
            }
            let hashUrl = Utils.makeUrl(path, params);
            openPageRouteUrl(null, "/bench/home", hashUrl);
        },
        // 跳转订单列表
        toViewOrder: function (row) {
            let contractId = row.contractId;
            let orderType = getEnumInfoWith('orderType', 'value', row.orderType);
            let path = null;
            if (orderType != null && orderType.name == 'GoodsOrder') {
                if (!Utils.isNoB(contractId) && contractId > 0) {
                    path = SwbContractGoodsOrderList.path;
                } else {
                    path = SwbGoodsOrderList.path;
                }
            } else {
                if (!Utils.isNoB(contractId) && contractId > 0) {
                    path = SwbContractServcOrderList.path;
                } else {
                    path = SwbServcOrderList.path;
                }
            }
            let params = {
                no: row.orderNo
            };
            let hashUrl = Utils.makeUrl(path, params);
            openPageRouteUrl(null, "/bench/home", hashUrl);
        },
        // 付款单
        toPayVoucher: function (row) {
            let query = {no: row.payVoucherNo};
            showRouteLayer({
                title: '付款明细',
                query: query,
                template: SwbPayVoucherList
            });
        },
        // 退款单
        toRefundVoucher: function (row) {
            let merchantType = getEnumInfoWith('merchantType', 'value', row.sellerType);
            let path = null;
            if (merchantType != null && merchantType.name == 'Vendor') {
                path = SwbRefundVoucherOfVendorList.path;
            } else {
                path = SwbRefundVoucherOfServicerList.path;
            }
            let params = {
                no: row.payVoucherNo
            };
            let hashUrl = Utils.makeUrl(path, params);
            openPageRouteUrl(null, "/bench/home", hashUrl);
        },
        // 发票附件
        viewInvoiceFile: function (row) {
            // 发票详情
            let theDlg = Vue.$showDialog({
                title: "发票 - 附件",
                showCloseBtn: true,
                okVisible: false,
                cancelText: '关闭',
                width: 1000,
                height: -60,
                template: '<swb-invoice-voucher-info :id="id" :onlyFile="onlyFile"></swb-invoice-voucher-info>',
                data: {
                    id: row.invoiceVoucherId,
                    onlyFile: true
                },
                methods: {},
                okClicked: function () {
                }
            });
        },
        // 结算明细
        viewPurchReceipt: function (row) {
            let params = {
                id: row.bizVoucherId
            };
            if (Utils.isTrue(this.settleProof.tmpBizFlag)) {
                openPurchReceiptTmpDetailDlg(null, params);
            } else {
                openPurchReceiptDetailDlg(params);
            }
        },
        // 设置业务标签
        toSetBuyerBizTag: function (event, row) {
            //
            let nextFlag = false;
            bizTagObj.getBizTagCount(this.bizAspect, function (count) {
                if (Utils.isNoB(count) || count <= 0) {
                    Toast.show("没有可选择的标签，请先维护相应的业务标签！", 1000, 'warning');
                    return false;
                } else {
                    nextFlag = true;
                }
            });
            if (Utils.isTrue(nextFlag)) {
                let optionRows = [];
                let curBtn = event.currentTarget;
                let buyerBizTag = row.buyerBizTag;
                let tagIdList = [];
                if (!Utils.isNoB(buyerBizTag)) {
                    buyerBizTag = buyerBizTag.substring(1, buyerBizTag.length - 1);
                    let idList = buyerBizTag.split("|") || [];
                    for (let i = 0; i < idList.length; i++) {
                        let id = idList[i];
                        tagIdList.push(parseInt(id));
                    }
                }
                this.tagIds = Utils.merge([], tagIdList);
                optionRows.push(row);
                //
                this.optionRows = Utils.merge([], optionRows);
                //
                let popoverRef = this.$refs.popoverRef;

                popoverRef.bindToReferer(
                    curBtn, 'click', {
                        showNow: true,
                        placement: 'left-start'
                    }
                )
            }
        },
        doBizTagConfirm: function (bizTagList) {
            let self = this;
            let optionRows = this.optionRows || [];
            let ids = optionRows.pluck("id") || [];
            let tagIds = bizTagList.pluck("id") || [];
            this.tagIds = tagIds;
            //
            let postData = {
                ids: ids,
                tagIds: tagIds
            };
            let theLoad = MsgBox.loading();
            settleApi.updateSettleTag(postData, function (result) {
                theLoad.hide();
                if (result.type === "info") {
                    //
                    let popoverRef = self.$refs.popoverRef;
                    popoverRef.doHide();
                    MsgBox.success("设置成功！");
                    self.getSettleProofDetail();
                } else {
                    MsgBox.warning(result.message);
                }
            });
        },
        doBizTagCancel: function () {
            let popoverRef = this.$refs.popoverRef;
            popoverRef.doHide();
        },
        exportPdf: function (id) {
            openPayVoucherInfoPdfDlg(id, false);
        },
        toPrint() {
            let collapsedBlocks = [];

            if (!this.showSettleInfoFlag) {
                collapsedBlocks.push('settleProof');
            }
            if (!this.showInvoiceFlag) {
                collapsedBlocks.push('settleInvoiceItems');
            }
            if (!this.showGoodsFlag) {
                collapsedBlocks.push('settleBizSrcs');
            }
            if (!this.showServWorkFlag) {
                collapsedBlocks.push('settleBizSrcs');
            }
            if (!this.showPayInfoFlag) {
                collapsedBlocks.push('settlePayItems');
            }
            if (!this.showPayPhasesFlag) {
                collapsedBlocks.push('settlePayPhases');
            }

            let settleProof = this.settleProof;
            let url = '/voucher/print/jsp';
            let postData = {
                bizType: 'biz.proof.yanshou.jiesuan',
                voucherId: settleProof.id,
                collapsedBlocks: collapsedBlocks.join(',')
            };
            let printUrl = Utils.makeUrl(getAppUrl(url), postData);
            Utils.setPageUrl(printUrl, '_blank');
        },
        arraySpanMethod({row, column, rowIndex, columnIndex}) {
            if (columnIndex === 0 || columnIndex === 1 || columnIndex === 2 || columnIndex === 3) {
                if (row.rowspan == 0) {
                    return [0, 0];
                } else {
                    return [row.rowspan, 1];
                }
            }
        },
        checkPhaseName: function (rule, value, callback) {
            if (Utils.isNoB(value)) {
                callback(new Error('请输入阶段名称'));
            } else if (value.length > 30) {
                callback(new Error('最多输入30个字,现有' + value.length + '个字'));
            } else {
                callback();
            }
        },
        changePhaseName: function (index) {
            let self = this;
            let row = self.settlePayPhaseInfo.settlePayPhaseList[index];
            let newPhaseName = row.phaseName;
            let _originalPhaseName = row._originalPhaseName;
            let rowFlag = row.rowFlag;

            // 如果名称未修改，直接返回
            if (newPhaseName === _originalPhaseName) {
                return;
            }

            // 检查名称是否唯一
            for (let i = 0; i < self.settlePayPhaseInfo.settlePayPhaseList.length; i++) {
                if (i !== index && self.settlePayPhaseInfo.settlePayPhaseList[i].rowFlag !== rowFlag && self.settlePayPhaseInfo.settlePayPhaseList[i].phaseName === newPhaseName) {
                    MsgBox.warning("阶段名称已存在");
                    // 恢复原来的名称
                    row.phaseName = _originalPhaseName;
                    return;
                }
            }

            // 更新原始名称
            for (let i = 0; i < self.settlePayPhaseInfo.settlePayPhaseList.length; i++) {
                if (self.settlePayPhaseInfo.settlePayPhaseList[i].rowFlag === rowFlag) {
                    self.settlePayPhaseInfo.settlePayPhaseList[i].phaseName = newPhaseName;
                    self.settlePayPhaseInfo.settlePayPhaseList[i]._originalPhaseName = newPhaseName;
                }
            }
        },
        changePhaseType(index) {
            let self = this;
            let row = self.settlePayPhaseInfo.settlePayPhaseList[index];
            for (let i = 0; i < self.settlePayPhaseInfo.settlePayPhaseList.length; i++) {
                if (i !== index && row.rowFlag === self.settlePayPhaseInfo.settlePayPhaseList[i].rowFlag) {
                    self.settlePayPhaseInfo.settlePayPhaseList[i].phaseType = row.phaseType;
                }
            }
            this.settlePayPhaseInfo.settlePayPhaseList = Utils.merge([], this.settlePayPhaseInfo.settlePayPhaseList);
        },
        changeAcntPeriodStartDate(index) {
            let self = this;
            let row = self.settlePayPhaseInfo.settlePayPhaseList[index];
            for (let i = 0; i < self.settlePayPhaseInfo.settlePayPhaseList.length; i++) {
                if (i !== index && row.rowFlag === self.settlePayPhaseInfo.settlePayPhaseList[i].rowFlag) {
                    self.settlePayPhaseInfo.settlePayPhaseList[i].acntPeriodStartDate = row.acntPeriodStartDate;
                }
            }
            this.settlePayPhaseInfo.settlePayPhaseList = Utils.merge([], this.settlePayPhaseInfo.settlePayPhaseList);
        },
        changeAcntPeriodDays(index) {
            let self = this;
            let row = self.settlePayPhaseInfo.settlePayPhaseList[index];
            for (let i = 0; i < self.settlePayPhaseInfo.settlePayPhaseList.length; i++) {
                if (i !== index && row.rowFlag === self.settlePayPhaseInfo.settlePayPhaseList[i].rowFlag) {
                    self.settlePayPhaseInfo.settlePayPhaseList[i].acntPeriodDays = row.acntPeriodDays;
                }
            }
            this.settlePayPhaseInfo.settlePayPhaseList = Utils.merge([], this.settlePayPhaseInfo.settlePayPhaseList);
        },
        changePhaseGapDays(index) {
            let self = this;
            let row = self.settlePayPhaseInfo.settlePayPhaseList[index];
            for (let i = 0; i < self.settlePayPhaseInfo.settlePayPhaseList.length; i++) {
                if (i !== index && row.rowFlag === self.settlePayPhaseInfo.settlePayPhaseList[i].rowFlag) {
                    self.settlePayPhaseInfo.settlePayPhaseList[i].phaseGapDays = row.phaseGapDays;
                }
            }
            this.settlePayPhaseInfo.settlePayPhaseList = Utils.merge([], this.settlePayPhaseInfo.settlePayPhaseList);
        },
        changeRatio() {
            let self = this;
            let settlePayPhaseList = this.settlePayPhaseInfo.settlePayPhaseList;
            let amountX = 0;
            let totalRatio = 0;
            for (let i = 0; i < settlePayPhaseList.length; i++) {
                if (!Utils.isNoB(settlePayPhaseList[i].ratio)) {
                    let amount = parseFloat((self.settleProof.settleAmount * parseFloat(settlePayPhaseList[i].ratio) * 0.01).toFixed(2));
                    settlePayPhaseList[i].amount = amount;
                    if (i < settlePayPhaseList.length - 1) {
                        amountX += amount;
                    }
                }
                totalRatio += parseFloat(settlePayPhaseList[i].ratio);
            }
            // 如果满100% 则最后一个用减法
            if (totalRatio === 100) {
                settlePayPhaseList[settlePayPhaseList.length - 1].amount = self.settleProof.settleAmount - parseFloat(amountX.toFixed(2));
            }
        },
        payPhaseRemoveItem(index) {
            let settlePayPhaseList = this.settlePayPhaseInfo.settlePayPhaseList;
            let row = settlePayPhaseList[index];

            const firstRowIndex = settlePayPhaseList.findIndex(r => r.rowFlag === row.rowFlag);
            if (settlePayPhaseList[firstRowIndex].rowspan > 1) {
                // 如果行是合并的，减少 rowspan
                settlePayPhaseList[firstRowIndex].rowspan -= 1;

                // 如果删除的就是合并行的第一行，且还有合并行,则把nameRowspan、col2Rowspan给到下一行
                if (firstRowIndex == index && settlePayPhaseList[firstRowIndex].rowspan >= 1) {
                    settlePayPhaseList[firstRowIndex + 1].rowspan = settlePayPhaseList[firstRowIndex].rowspan;
                    settlePayPhaseList[firstRowIndex + 1].visible = true;
                }
            }
            // 删除当前行
            settlePayPhaseList.splice(index, 1);
            // 重新计算rowFlag
            let preRow = null;
            for (let i = 0; i < settlePayPhaseList.length; i++) {
                if (preRow == null) {
                    settlePayPhaseList[i].newRowFlag = 'row' + i;
                    preRow = settlePayPhaseList[i];
                } else if (preRow.rowFlag == settlePayPhaseList[i].rowFlag) {
                    settlePayPhaseList[i].newRowFlag = preRow.newRowFlag;
                } else {
                    settlePayPhaseList[i].newRowFlag = 'row' + i;
                    preRow = settlePayPhaseList[i];
                }
            }
            for (let i = 0; i < settlePayPhaseList.length; i++) {
                settlePayPhaseList[i].rowFlag = settlePayPhaseList[i].newRowFlag;
            }

            this.settlePayPhaseInfo.settlePayPhaseList = Utils.merge([], settlePayPhaseList);

            this.changeRatio();
        },
        addSettlePayPhase() {
            let settlePayPhaseList = this.settlePayPhaseInfo.settlePayPhaseList;
            if (settlePayPhaseList.length > 0 && settlePayPhaseList[settlePayPhaseList.length - 1].phaseType === 9) {
                return;
            }
            settlePayPhaseList.push({
                phaseName: null,
                phaseType: 1,
                calcBasis: 0,
                ratio: null,
                amount: null,
                acntPeriodStartDate: null,
                acntPeriodDays: null,
                phaseGapDays: null,
                payMethod: 1,
                rowspan: 1,
                visible: true,
                rowFlag: 'row' + settlePayPhaseList.length,
                _originalPhaseName: null
            });
            this.settlePayPhaseInfo.settlePayPhaseList = Utils.merge([], settlePayPhaseList);
        },
        addPhaseItem(index) {
            let currentRow = this.settlePayPhaseInfo.settlePayPhaseList[index];
            let newRow = {
                phaseName: currentRow.phaseName,
                phaseType: currentRow.phaseType,
                calcBasis: 0,
                ratio: null,
                amount: null,
                acntPeriodStartDate: currentRow.acntPeriodStartDate,
                acntPeriodDays: currentRow.acntPeriodDays,
                phaseGapDays: currentRow.phaseGapDays,
                payMethod: 1,
                rowspan: 1,
                visible: false,
                rowFlag: currentRow.rowFlag,
                _originalPhaseName: currentRow.phaseName
            };
            // 插入新行
            this.settlePayPhaseInfo.settlePayPhaseList.splice(index + 1, 0, newRow);
            // 更新当前行的 rowspan
            currentRow.rowspan += 1;
        },
        validateRatio: function (rule, value, callback) {
            if (Utils.isNoB(value)) {
                callback(new Error('请输入付款比例'));
            } else {
                if (!Utils.isMoneyStr(value) || parseFloat(value) < 0.01 || parseFloat(value) > 100) {
                    callback(new Error('请输入0.01~100的数字'));
                } else {
                    callback();
                }
            }
        },
        validateIntNotNull: function (rule, value, callback) {
            if (Utils.isNoB(value)) {
                callback(new Error('该属性不能为空'));
            } else {
                if (!Utils.isIntStr(value) || value <= 0) {
                    callback(new Error('请输入正整数'));
                } else {
                    callback();
                }
            }
        },
        getDlgResult: function () {
            let self = this;
            let result = {
                type: 'info'
            };
            let settleProof = this.settleProof;
            let settlePayPhaseList = Utils.merge([], this.settlePayPhaseInfo.settlePayPhaseList);
            if (settleProof.contractId == -1 && !Utils.isNoB(settlePayPhaseList) && settlePayPhaseList.length > 0) {
                this.$refs['ruleForm'].validate(function (valid) {
                    if (valid) {
                        let totalRatio = 0;
                        for (let i = 0; i < settlePayPhaseList.length; i++) {
                            // 下一个项的账期起算日不能小于上一个
                            if (i > 0 && settlePayPhaseList[i].acntPeriodStartDate < settlePayPhaseList[i - 1].acntPeriodStartDate) {
                                result.type = 'warn';
                                result.message = '下一个阶段项的账期起算日不能小于上一个';
                                return result;
                            }
                            // 总比例不可大于100%
                            totalRatio += parseFloat(settlePayPhaseList[i].ratio);
                            // 不是最后一个阶段不可设置类型为尾款
                            if (settlePayPhaseList[i].rowFlag !== settlePayPhaseList[settlePayPhaseList.length - 1].rowFlag && settlePayPhaseList[i].phaseType === 9) {
                                result.type = 'warn';
                                result.message = '只有最后一个阶段才能设置阶段类型为尾款';
                                return result;
                            }
                            settlePayPhaseList[i].acntPeriodStartDate = settlePayPhaseList[i].acntPeriodStartDate.format('yyyy-MM-dd');
                            settlePayPhaseList[i].seqNo = i;
                        }
                        if (totalRatio > 100) {
                            result.type = 'warn';
                            result.message = '付款比例总和不能超过100%';
                            return result;
                        } else if (totalRatio < 100) {
                            result.message = '当前付款阶段比例不是100%，确认要继续操作吗？';
                        }
                        // 同阶段的付款方式不可重复
                        let dataX = {};
                        for (let i = 0; i < settlePayPhaseList.length; i++) {
                            if (dataX[settlePayPhaseList[i].rowFlag] == null) {
                                dataX[settlePayPhaseList[i].rowFlag] = [settlePayPhaseList[i]];
                            } else {
                                let listX = dataX[settlePayPhaseList[i].rowFlag];
                                // 循环listX
                                for (let j = 0; j < listX.length; j++) {
                                    if (listX[j].payMethod === settlePayPhaseList[i].payMethod) {
                                        result.type = 'warn';
                                        result.message = '同阶段的付款方式不可重复';
                                        return result;
                                    }
                                }
                                listX.push(settlePayPhaseList[i]);
                                dataX[settlePayPhaseList[i].rowFlag] = listX;
                            }
                        }
                    } else {
                        result.type = 'warn';
                        result.message = '校验失败';
                    }
                });
            }
            // 转换为提交结构
            let settlePayPhaseListX = [];
            let settlePayPhaseMap = [];
            // 循环 settlePayPhaseList
            for (let i = 0; i < settlePayPhaseList.length; i++) {
                let settlePayPhaseItem = settlePayPhaseList[i];
                let settlePayItemCO = {};
                settlePayItemCO.phaseName = settlePayPhaseItem.phaseName;
                settlePayItemCO.calcBasis = settlePayPhaseItem.calcBasis;
                settlePayItemCO.ratio = settlePayPhaseItem.ratio;
                settlePayItemCO.amount = settlePayPhaseItem.amount;
                settlePayItemCO.payMethod = settlePayPhaseItem.payMethod;
                settlePayItemCO.seqNo = settlePayPhaseItem.seqNo;
                if(!settlePayPhaseMap[settlePayPhaseItem.phaseName]) {
                    settlePayPhaseMap[settlePayPhaseItem.phaseName] = [];
                    let phaseX = {};
                    phaseX.phaseType = settlePayPhaseItem.phaseType;
                    phaseX.phaseName = settlePayPhaseItem.phaseName;
                    phaseX.acntPeriodBasis = settlePayPhaseItem.acntPeriodBasis;
                    phaseX.acntPeriodStartDate = settlePayPhaseItem.acntPeriodStartDate;
                    phaseX.acntPeriodDays = settlePayPhaseItem.acntPeriodDays;
                    phaseX.phaseGapDays = settlePayPhaseItem.phaseGapDays;
                    settlePayPhaseListX.push(phaseX);
                }
                settlePayPhaseMap[settlePayPhaseItem.phaseName].push(settlePayItemCO);
            }
            for (let i = 0; i < settlePayPhaseListX.length; i++) {
                settlePayPhaseListX[i].settlePayItemList = settlePayPhaseMap[settlePayPhaseListX[i].phaseName];
                settlePayPhaseListX[i].seqNo = i;
            }
            let resultData = {
                id: this.proofId,
                auditState: this.auditState,
                auditDesc: this.auditDesc,
                memo: this.memo,
                acntPeriodForm: this.settlePayPhaseInfo.acntPeriodForm,
                settlePayPhaseList: settlePayPhaseListX
            };
            result.data = resultData;
            return result;
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/compo/settle/SettleProofAudit.vue